import MaintenanceMessages from './MaintenanceMessages';

export default MaintenanceMessages;
